// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import TimelogEditScreen from "../../../src/screens/timelogs/edit-screen"
import ScreenTitle from "../../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} TimelogEditRouteProps */

/** @typedef {Record<string, never>} TimelogEditRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<TimelogEditRouteProps, TimelogEditRouteState>}
 */
class TimelogEditRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("Edit timelog")}</ScreenTitle>
        <TimelogEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<TimelogEditRouteProps>} */
const TimelogEditRouteComponent = memo(shapeComponent(TimelogEditRoute))

export default TimelogEditRouteComponent
